export function simplePluralize(n, textForms) {
  /* eslint-disable */
  const n1 = Number(n)
  const n2 = Number(n1) % 10
  if (n1 > 10 && n1 < 20) return `${n1} ${textForms[2]}`
  if (n2 > 1 && n2 < 5) return `${n1} ${textForms[1]}`
  if (n2 == 1) return `${n1} ${textForms[0]}`
  return `${n1} ${textForms[2]}`
}
